import { render } from "./JoinOurteam.vue?vue&type=template&id=a2b1e120&scoped=true"
import script from "./JoinOurteam.vue?vue&type=script&lang=js"
export * from "./JoinOurteam.vue?vue&type=script&lang=js"

import "./JoinOurteam.vue?vue&type=style&index=0&id=a2b1e120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2b1e120"]])

export default __exports__